import React, { Component } from 'react'
import NotificationSystem from 'react-notification-system'
import _ from 'lodash'
class Notification extends Component{
    constructor(props) {
        super(props);
        this.state = {
            render: false
        };
    }
    componentDidMount(){
        this._notificationSystem = this.refs.notificationSystem;
    }
    componentWillUpdate(nextProps, nextState) {
        if(nextProps.message && nextProps.message.message && !_.isEmpty(nextProps.message.message)){
            const caso = nextProps.message.message.caso|| null
            const comment = nextProps.message.message.comment || null
            this._addNotification(nextProps.message.message.message, caso, comment)
        }
    }
    _notificationSystem = null
    _addNotification(message, caso, comment) {
        // event.preventDefault();
        let notificationProps;
        if(caso){
            notificationProps = {
                title: "Cambio de status",
                message: message,
                level: 'info',
                action: {
                    label: 'Ir al caso',
                    callback: function() {
                        window.location.href = `/casos/${caso.id}`
                    }
                }
            }
        }else{
            notificationProps = {
                title: "Nuevo comentario",
                message: message,
                level: 'warning',
                action: {
                    label: 'Ir al caso',
                    callback: function() {
                        window.location.href = `/casos/${comment.caso_id}`
                    }
                }
            }
        }
        this._notificationSystem.addNotification( notificationProps );
    }
    render(){
        return <NotificationSystem ref="notificationSystem" />
    }
}
export default Notification


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/Notification.jsx